import React from "react";
import { Reveal } from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
    ["How is Sweet Pearls made?", "Every cup is handcrafted in small batches each morning using real vanilla bean custard, fresh bananas, and premium ingredients — never frozen or mass-produced."],
    ["What are my fulfillment options?", "You can choose local pickup (ready in about 2 hours), same-day local delivery in our service area, or nationwide chilled shipping (typically 2–3 days)."],
    ["How should I store my pudding?", "Keep it refrigerated and enjoy within 2–3 days for the freshest taste. Puddings with fresh fruit are best enjoyed within 2 days."],
    ["Do you accommodate allergies?", "All of our puddings contain milk, eggs, wheat and soy, and are made in a facility that also processes tree nuts. Please check each product's allergen information."],
    ["Can I build a custom variety box?", "Absolutely! Head to Build a Box, pick a size, and tap to add your favorite flavors. Great for gifts and parties."],
    ["Do you cater events?", "Yes — birthdays, weddings, baby showers, corporate events and more. Request a quote from our Catering page and we'll respond within 24 hours."],
    ["What payment methods do you accept?", "We accept all major credit and debit cards, plus Apple Pay and Google Pay through our secure Stripe checkout."],
    ["Can I track my order?", "Yes. Use your order number on the Track Order page, or sign in to your account to see all order statuses in one place."],
];

export default function FAQ() {
    return (
        <div className="mx-auto max-w-3xl px-5 py-16">
            <Reveal className="text-center">
                <p className="text-sm font-semibold uppercase tracking-widest text-caramel">FAQ</p>
                <h1 className="mt-2 font-serif text-4xl font-semibold text-roast sm:text-5xl">Frequently asked questions</h1>
                <p className="mt-3 text-mocha">Everything you need to know about ordering Sweet Pearls.</p>
            </Reveal>
            <Reveal delay={0.1}>
                <Accordion type="single" collapsible className="mt-10 rounded-3xl border border-caramel/10 bg-white px-6 shadow-warm">
                    {FAQS.map(([q, a], i) => (
                        <AccordionItem key={i} value={`f${i}`} className="border-caramel/10">
                            <AccordionTrigger data-testid={`faq-${i}`} className="py-5 text-left font-serif text-lg text-roast hover:no-underline">{q}</AccordionTrigger>
                            <AccordionContent className="pb-5 text-mocha">{a}</AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    );
}
